<script setup lang="ts">
import { STATE_CONTENT_ADDRESS_SYSTEM } from '@/constants/statesOfAddressSystem'

import { useAddressSystemStateStore } from '@/store/addressSystem'

const { dialogContent } = storeToRefs(useAddressSystemStateStore())

const listTitles = {
  DELIVERY_SELECT: {
    title: 'Куда заказать',
    description:
      'При изменении адреса и способа получения может поменяться корзина и ассортимент в каталоге',
  },
  ALL_DELIVERY_METHODS: {
    title: 'Выберите способ получения заказа и укажите свой адрес',
    description:
      'Рассчитаем время и стоимость доставки и подберем ближайшие точки самовывоза и рестораны',
  },
  ONLY_DELIVERY: {
    title: 'Укажите свой адрес',
    description: 'Рассчитаем время и стоимость доставки',
  },
}

type Props = {
  isCheckPickup: boolean
  isCheckHall: boolean
}

const props = defineProps<Props>()

// Текущее состояния заголовка с описанием в зависимости от способов доставки
const currentHeadline = computed(() => {
  const { isCheckPickup, isCheckHall } = props

  if (dialogContent.value === STATE_CONTENT_ADDRESS_SYSTEM.SELECT)
    return listTitles.DELIVERY_SELECT

  if (!isCheckPickup && !isCheckHall) return listTitles.ONLY_DELIVERY
  else return listTitles.ALL_DELIVERY_METHODS
})
</script>

<template>
  <div class="address-system-headline">
    <div class="address-system-headline__title">
      {{ currentHeadline.title }}
    </div>
    <span class="address-system-headline__description">
      {{ currentHeadline.description }}
    </span>
  </div>
</template>

<style scoped lang="scss">
.address-system-headline {
  &__title {
    margin-bottom: 10px;
    font-size: 16px;
    font-weight: 800;
    line-height: 22px;
    color: var(--ui-secondary);

    @include media('>tablet') {
      font-size: 20px;
    }
  }

  &__description {
    display: block;
    max-width: 272px;
    margin-bottom: 30px;
    font-size: 14px;
    font-weight: 600;
    line-height: 17px;
    color: var(--ui-dark-grey);
  }
}
</style>
